import React, { useEffect, useState } from 'react'
import { CommonAxiosGet } from '../CommonUtils/CommonAxios';
import CommonReactTable from '../CommonUtils/CommonReactTable';
import { config } from '../CommonUtils/CommonURLS';

export default function UnivwiseReport() {



    const [projectdata, serProjectdata] = useState([]);
    function GetProjectStatusData() {
        let url = `${config.url.FAC_URL}getUnvWiseReport`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01" &&
                res?.data?.UnvWiseReport?.length > 0) {
                serProjectdata(res?.data?.UnvWiseReport);
            } else {
                serProjectdata([]);
            }
        });
    }
    useEffect(() => {
        GetProjectStatusData();

    }, []);


    const SubjectReportColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,
        },
        {
            id: "dept_name",
            header: "Name of the Department / Subject",
            accessorKey: "dept_name",
        },
        {
            id: "no_of_san_posts",
            header: "No of sanctioned posts (GO Ms No 95 dt 16-09-2023)",
            accessorKey: "no_of_san_posts",
        },
        {
            id: "no_of_reg_fac_working",
            header: "No of regular faculty working",
            accessorKey: "no_of_reg_fac_working",
        },
        {
            id: "no_of_contract_fac_working",
            header: "No of contract faculty working",
            accessorKey: "no_of_contract_fac_working",
        },
        {
            id: "no_of_guest_fac_working",
            header: "No of Guest faculty working",
            accessorKey: "no_of_guest_fac_working",
        },
        {
            id: "no_of_adhoc_fac_working",
            header: "No of Adhoc faculty working",
            accessorKey: "no_of_adhoc_fac_working",
        },
    ];
    return (
        <>

            {projectdata?.length > 0 && (
                <>

                    <div className="overal-stathead">
                        <span>Subject Faculty  Report</span>
                    </div>
                    <div className="all-table-content">
                        <div className="table-responsive mt--40">
                            <CommonReactTable
                                data={projectdata}
                                columns={SubjectReportColumns}
                                filename="Subject Faculty Details Report"
                                headerName="Subject Faculty  Details Report"
                                showFooter={true}
                                showPagination={false}


                            />
                        </div>
                    </div>
                </>
            )}








        </>)
}

